<template>
    <div>
        <TopbarCustom :loggedIn="true"></TopbarCustom>
        <div id="main-view">

            <div class="page-container" v-if="loading">
                <LoadingBar clazz="center-floating full-view"></LoadingBar>
            </div>
            <div class="page-container" v-if="!loading">
                <div class="payment-status">
                <img class="img-fluid" v-if="!error" src="@/assets/images/Illustrations/illu_receipt.svg" width="284" height="280" alt="Pago exitoso" />
                <img v-if="error" class="img-fluid" src="@/assets/images/Illustrations/illustration-payment-error.svg" width="284" height="280" alt="No encontrado" />
                <h3 v-if="!error" class="c-text_title">{{$t('paymentStatus.success.thanks')}}</h3>
                <div v-if="!error">
                    <p v-html="$t('paymentStatus.success.download-receipt-text', {organization: order.organization})"></p>
                    <slot></slot>
                </div>
                <h3 v-if="error" class="c-text_title">{{$t('paymentStatus.error.not-found')}}</h3>
                <p v-if="error">{{$t('paymentStatus.error.not-found-messagge')}}<slot></slot> </p>

                <div class="transaction-info" v-if="!error">
                    <div class="item" style="flex-direction: column;">
                        <div class="description w-100 text-align-c">
                            {{$t('paymentStatus.success.date')}}
                        </div>
                        <div class="info w-100 text-align-c">
                            {{order.date}}
                        </div>
                    </div>
                    <div class="item" style="flex-direction: column;">
                        <div class="description w-100 text-align-c">
                            {{$t('paymentStatus.success.folio')}}
                        </div>
                        <div class="info w-100 text-align-c">
                            {{order.folio}}
                        </div>
                    </div>
                    <div class="item" style="flex-direction: column;">
                        <div class="description w-100 text-align-c">
                            {{$t('paymentStatus.success.authCode')}}
                        </div>
                        <div class="info w-100 text-align-c">
                            {{order.authCode}}
                        </div>
                    </div>
                    <div class="item" style="flex-direction: column;">
                        <div class="description w-100 text-align-c">
                            {{$t('paymentStatus.success.totalPay')}}
                        </div>
                        <div class="info w-100 text-align-c">
                            {{order.total | currency}}
                        </div>
                    </div>
                </div>
                <div class="button-container" v-if="!error && !loadingReceipt">
                    <a   @click="downloadReceipt()" class="sm button button-filled button-primary" tabindex="">
                        {{$t('paymentStatus.success.download-receipt')}}
                    </a>
                </div>
                <div class="button-container" v-if="!error && loadingReceipt">
                    <a  class="sm button button-filled button-primary" tabindex="">
                        <LoadingSimple clazz="small-load no-text"/>
                    </a>
                </div>
            </div>
            </div>
        </div>
    </div>
</template>

<script>
import TopbarCustom from '@/components/Topbar.vue'
import ToastSnotify from '@/mixins/toastSnotify.mixin';
import LoadingBar from '@/components/LoadingBar.vue';
import ordersApi from "@/api/orders.api";
import LoadingSimple from '@/components/LoadingSimple.vue';
import axios from 'axios';

export default {
    name: "PaymentStatus",
    mixins: [
        ToastSnotify
    ],
    components: {
        TopbarCustom,
        LoadingBar,
        LoadingSimple
    },
    data () {
        return {
            loading: true,
            error: false,
            loadingReceipt: false,
            order: {}
        }
    },
    beforeMount(){
        ordersApi.getInfoTransaction(this.$route.params.orderId, this.$route.params.organizationId).then(response=>{
            if(response.data.error){
                this.error = true;
            } else {
                this.order = response.data.object;
                this.error = false;
            }
            this.loading = false;
        }).catch(()=>{
            this.loading = false;
            this.error = true;
        })
    },
    mounted(){
    },
    methods: {
        downloadReceipt() {
            this.loadingReceipt = true;
            ordersApi.getReceiptPDF(this.$route.params.orderId, this.$route.params.organizationId).then((data) => {
                if(data.data.error){
                    this.displayNotificationError(this.$t('paymentStatus.success.error-download-receipt'));
                    this.loadingReceipt = false;
                } else {
                    axios.get(data.data.object.renderUrl, { responseType: 'blob' })
                    .then(response => {
                        const blob = new Blob([response.data], { type: 'application/pdf' })
                        const link = document.createElement('a')
                        link.href = URL.createObjectURL(blob)
                        link.download = `${this.$route.params.orderId}.pdf`
                        link.click()
                        URL.revokeObjectURL(link.href)
                        this.loadingReceipt = false;
                    }).catch(() =>{
                        this.displayNotificationError(this.$t('paymentStatus.success.error-download-receipt'));
                        this.loadingReceipt = false;
                    })
                }
            }).catch(() => {
                this.displayNotificationError(this.$t('paymentStatus.success.error-download-receipt'));
                this.loadingReceipt = false;
            });
        },
    },
};
</script>
